var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-select-field',{attrs:{"value":_vm.value,"label":"Currency","name":"currency","id-key":"code","value-key":"code","label-key":"code","options":_vm.currencySymbols},on:{"input":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }